import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadUsuario() {
  const [listafunc, setlistafunc] = useState([]);
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodusuario, setedtcodusuario] = useState(0);
  const [edtusuario, setedtusuario] = useState("");
  const [edtsenha, setedtsenha] = useState("");
  const [edtcodfuncionario, setedtcodfuncionario] = useState(0);
  const [edtativo, setedtativo] = useState("");
  const [edttipo, setedttipo] = useState("");
  const [permissoes, setPermissoes] = useState([]);

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const Permissao = [
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Empresa",
      "caminho": "/cadastro/empresa",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"    
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Funcionario",
      "caminho": "/cadastro/funcionario",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Usuario",
      "caminho": "/cadastro/usuario",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Grupo de Produto",
      "caminho": "/cadastro/grupoproduto",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Produto",
      "caminho": "/cadastro/produto",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Kit",
      "caminho": "/cadastro/kit",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Equipe",
      "caminho": "/cadastro/equipe",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Cliente",
      "caminho": "/cadastro/cliente",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Fornecedor",
      "caminho": "/cadastro/fornecedor",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Conta",
      "caminho": "/cadastro/categoriafinanceira",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Moeda",
      "caminho": "/cadastro/condicoespagamento",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Cadastro de Banco",
      "caminho": "/cadastro/caixabanco",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Manutenção",
      "caminho": "/operacoes/manutencao",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Lançamento de Titulo",
      "caminho": "/operacoes/lanctitulo",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Lançamento de Despesa",
      "caminho": "/operacoes/lancdespesa",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Lançamento de Folha",
      "caminho": "/operacoes/lancfolhapagamento",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Lançamento de Viagem",
      "caminho": "/operacoes/viagem",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Gerar Ficha",
      "caminho": "/operacoes/gerarficha",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Caixa",
      "caminho": "/operacoes/caixa",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },

    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Cliente",
      "caminho": "/relatorio/cliente",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Ficha Vinculada",
      "caminho": "/relatorio/fichavinculada",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Ficha Cobrar",
      "caminho": "/relatorio/fichacobrar",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Ficha Cobradas",
      "caminho": "/relatorio/fichacobradas",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Vendas Por Vendedor",
      "caminho": "/relatorio/vendaporvendedor",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Vendas Por Equipe",
      "caminho": "/relatorio/vendaporequipe",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    },
    {
      "codusuarioperfil": 0,
      "rotina": "Relatório de Vendas Em Aberto",
      "caminho": "/relatorio/vendaemaberto",
      "permissao_ver": "S",
      "permissao_inserir": "S",
      "permissao_editar": "S",
      "permissao_excluir": "S",
      "permissao_imprimir": "S"
    }
  ];

  const handleOpen = (cad) => {
    setedtcodusuario(cad.codusuario);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarUsuario();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListaFunc() {
    api
      .get("v1/cadastro/funcionario", {
        params: {
          busca: abusca,
          usapaginacao: 'N',
          offset: 0
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistafunc(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarUsuario() {
    api
      .get("v1/cadastro/usuario", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/usuario",
        {
          usuario: edtusuario,
          senha: edtsenha,
          codfuncionario: edtcodfuncionario,
          ativo: edtativo,
          tipo: edttipo,
          excluido: "N",
          codempresa: 1,
          perfil: permissoes
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarUsuario();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/usuario",
        {
          codusuario: edtcodusuario,
          codfuncionario: edtcodfuncionario,
          usuario: edtusuario,
          senha: edtsenha,
          ativo: edtativo,
          tipo: edttipo,
          codempresa: 1,
          perfil: permissoes
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarUsuario();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/usuario", {
        params: {
          codusuario: edtcodusuario,
          motivo: edtMotivo,
          codusuario1: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarUsuario();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  useEffect(() => {
    ListarUsuario();
  }, [abusca, showform, handleConfirma]);

  useEffect(() => {
    ListaFunc();
  }, [showform]);

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodusuario(0);
    setedtusuario("");
    setedtsenha("");
    setedtcodfuncionario(0);
    setedtativo("S");
    setedttipo("V");

    setPermissoes(Permissao)
  }

  function openModalEditar(props) {
    api
      .get("/v1/cadastro/usuario/usuarioum", {
        params: {
          codusuario: props.codusuario,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowform(true);
        setnovo(false);

        setedtcodusuario(response.data.codusuario);
        setedtusuario(response.data.usuario);
        setedtsenha(response.data.senha);
        setedtcodfuncionario(response.data.codfuncionario);
        setedtativo(response.data.ativo);
        setedttipo(response.data.tipo);

        const perfilAPI = response.data.perfil || [];

        const perfilFinal = Permissao.map((itemDefault) => {
          const encontrado = perfilAPI.find(
            (item) => item.rotina === itemDefault.rotina
          );

          if (encontrado) {
            return {
              ...itemDefault,
              codusuarioperfil: encontrado.codusuarioperfil,
              permissao_ver: encontrado.permissao_ver,
              permissao_inserir: encontrado.permissao_inserir,
              permissao_editar: encontrado.permissao_editar,
              permissao_excluir: encontrado.permissao_excluir,
              permissao_imprimir: encontrado.permissao_imprimir,
            };
          }

          return itemDefault;
        });

        setPermissoes(perfilFinal);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  const handleCheckboxChange = (index, campo) => {
    const novaLista = [...permissoes];
    novaLista[index][campo] =
      novaLista[index][campo] === "S" ? "N" : "S";
    setPermissoes(novaLista);
  }; 

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>

              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-sm-6">
                      <label htmlFor="usuario" className="form-label">
                        Usuário
                      </label>
                      <input
                        type="text"
                        id="usuario"
                        className="form-control"
                        placeholder="Usuário"
                        value={edtusuario}
                        onChange={(e) => setedtusuario(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="senha" className="form-label">
                        Senha
                      </label>
                      <input
                        type="password"
                        id="senha"
                        className="form-control"
                        placeholder="Senha"
                        value={edtsenha}
                        onChange={(e) => setedtsenha(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <label htmlFor="funcionario" className="form-label">
                        Funcionário
                      </label>
                      <select
                        className="form-select"
                        id="funcionario"
                        value={edtcodfuncionario}
                        onChange={(e) => setedtcodfuncionario(e.target.value)}
                      >
                        <option value="0">Escolha a funcionário</option>
                        {listafunc.map(function (func) {
                          return (
                            <option
                              key={func.codfuncionario}
                              value={func.codfuncionario}
                            >
                              {func.nome}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-sm-3">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="ativo1"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label className="form-check-label">Sim</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div>
                        <label htmlFor="tipo1" className="form-label">
                          Tipo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="tipo1"
                            type="radio"
                            name="tipo"
                            value="C"
                            onChange={(e) => setedttipo(e.target.value)}
                            checked={edttipo === "C"}
                          />
                          <label className="form-check-label">Chefe</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipo"
                            value="V"
                            onChange={(e) => setedttipo(e.target.value)}
                            checked={edttipo === "V"}
                          />
                          <label className="form-check-label">Vendedor</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h4>Controle de Permissões</h4>
                  <table className="table table-bordered table-hover mt-3">
                    <thead className="table-dark">
                      <tr>
                        <th>Rotina</th>
                        <th>Ver</th>
                        <th>Inserir</th>
                        <th>Editar</th>
                        <th>Excluir</th>
                        <th>Imprimir</th>
                      </tr>
                    </thead>

                    <tbody>
                      {permissoes.map((item, index) => (
                        <tr key={index}>
                          <td>{item.rotina}</td>

                          <td>
                            <input
                              type="checkbox"
                              checked={item.permissao_ver === "S"}
                              onChange={() => handleCheckboxChange(index, "permissao_ver")}
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={item.permissao_inserir === "S"}
                              onChange={() =>
                                handleCheckboxChange(index, "permissao_inserir")
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={item.permissao_editar === "S"}
                              onChange={() =>
                                handleCheckboxChange(index, "permissao_editar")
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={item.permissao_excluir === "S"}
                              onChange={() =>
                                handleCheckboxChange(index, "permissao_excluir")
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={item.permissao_imprimir === "S"}
                              onChange={() =>
                                handleCheckboxChange(index, "permissao_imprimir")
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Usuário</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os usuários da empresa que terão acesso
            ao sistema.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou usuário"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/usuario")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Usuário</th>
                <th className="fantasia">Funcionário</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codusuario}>
                    <th>{item.codusuario}</th>
                    <th>{item.usuario}</th>
                    <th>{item.funcionario}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/usuario")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/usuario")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadUsuario;
